// Components
import React, {useEffect} from "react";
import { useDocNav } from "./DocNavContext";
import BaseButton from "../../components/base/Button";
import CustomGPTLeaking from "./injections/CustomGPTLeaking";
import PageEnum from "../../components/enums/PageEnum";

function PromptLeakingDocumentation() {
  const { setDocPageId } = useDocNav();
  // sessionStorage.setItem('handout-framework', "false"); // Set false, seems like it should be available.
  // sessionStorage.setItem('handout-techniques', "false"); // Set false, seems like it should be available.

  useEffect(() => {
    setDocPageId(PageEnum.PromptLeaking);
    document.title = "Crafting AI Prompts Framework - Prompt Leaking";
    return () => setDocPageId(null);
  }, []);

  return (
      <>

        <CustomGPTLeaking />

        <BaseButton url={"/documentation/adversarial-prompting/prompt-jailbreak#prompt-jailbreak"} styles="max-w-full px-8 py-4 bg-gradient-to-r from-[#468ef9] to-[#0c66ee] border border-[#0c66ee] text-white">
            Next: Prompt Jailbreak
        </BaseButton>
    </>
  );
}

export default PromptLeakingDocumentation;
